/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

/* eslint-disable no-duplicate-imports */
import { Alert, Module, Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { ICookieComplianceViewProps } from './dlvry-cookie-compliance';

const CookieComplianceView: React.FC<ICookieComplianceViewProps> = props => {
    const {
        CookieComplianceBanner,
        AlertProps,
        Content,
        ButtonContainer,
        acceptButton,
        acceptEssentialButton,
        customizeButton,
        heading,
        text,
        links
    } = props;

    return (
        <Module {...CookieComplianceBanner}>
            <Alert className={AlertProps.className} color={AlertProps.color} fade={AlertProps.fade}>
                <Node {...Content}>
                    {heading}
                    {text}
                    {links}
                </Node>
                <Node {...ButtonContainer}>
                    {customizeButton}
                    {acceptEssentialButton}
                    {acceptButton}
                </Node>
            </Alert>
            {props.customizeModal}
        </Module>
    );
};
export default CookieComplianceView;
